"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var _xychart = require("@visx/xychart");
var _gradient = require("@visx/gradient");
var _curve = require("@visx/curve");
var _shape = require("@visx/shape");
var _scale = require("@visx/scale");
const colors = {
  white: "#FFFFFF",
  black: "#1B1B1B",
  gray: "#98A7C0",
  darkGray: "#2A2A2A",
  accent: "#2bbe88",
  darkAccent: "#256769"
};
const getData = () => {
  const data = [[1, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [2, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [3, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [4, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [5, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [6, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [7, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [8, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [9, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [10, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [11, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [12, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [13, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [14, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [15, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [16, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [17, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [18, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [19, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [20, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [21, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [22, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [23, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [24, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [25, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [26, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [27, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [28, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [29, Math.floor(Math.random() * (25 - 1 + 1) + 1)], [30, Math.floor(Math.random() * (25 - 1 + 1) + 1)]];
  return data;
};
const Line = _ref => {
  let {
    data1 = getData(),
    yScaleRatio = 2,
    color = colors.accent,
    height = 24,
    width = 100
  } = _ref;
  const padding = 1;
  const xScale = (0, _scale.scaleLinear)({
    domain: [1, data1.length],
    range: [0 + padding, width - padding]
  });
  const yScale = (0, _scale.scaleLinear)({
    domain: [0, Math.max(...data1.map(d => d[1])) * yScaleRatio],
    range: [height - padding, padding * 2]
  });
  return /*#__PURE__*/React.createElement(_xychart.XYChart, {
    height: height,
    width: width,
    xScale: {
      type: 'band'
    },
    yScale: {
      type: 'linear'
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "negative"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 0,
    width: 30,
    height: 30
  }))), /*#__PURE__*/React.createElement(_gradient.LinearGradient, {
    id: 'line-gradient-' + color.replace('#', ''),
    from: color ? color : colors.accent,
    to: color ? color : colors.accent
  }), /*#__PURE__*/React.createElement(_shape.LinePath, {
    data: data1,
    x: d => xScale(d[0]),
    y: d => yScale(d[1]),
    stroke: "url('#line-gradient-".concat(color.replace('#', ''), "')"),
    strokeWidth: 1.25,
    curve: _curve.curveNatural,
    markerEnd: "url(#marker-circle)"
  }));
};
var _default = exports.default = Line;